var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessageCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.667545 7.99935C0.667545 3.94926 3.95079 0.666016 8.00088 0.666016C12.051 0.666016 15.3342 3.94926 15.3342 7.99935C15.3342 12.0494 12.051 15.3327 8.00088 15.3327C6.88573 15.3327 5.82714 15.0833 4.8793 14.6369L0.484375 15.5159L1.36336 11.1209C0.916897 10.1731 0.667545 9.1145 0.667545 7.99935ZM8.00088 1.99935C4.68717 1.99935 2.00088 4.68564 2.00088 7.99935C2.00088 8.98278 2.23696 9.90913 2.65496 10.7267L2.76062 10.9333L2.18405 13.8162L5.06693 13.2396L5.27358 13.3453C6.0911 13.7633 7.01745 13.9993 8.00088 13.9993C11.3146 13.9993 14.0009 11.3131 14.0009 7.99935C14.0009 4.68564 11.3146 1.99935 8.00088 1.99935Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageCircle);
export default __webpack_public_path__ + "static/media/message-circle.8155eefc53acab549928f407dc835507.svg";
export { ForwardRef as ReactComponent };